import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center shadow-elevation-2">
          <Icon name="Users" size={32} color="white" />
        </div>
      </div>

      {/* Title and Subtitle */}
      <div className="space-y-2" dir="rtl">
        <h1 className="text-2xl font-bold text-foreground font-arabic">
          الإتحاد العام لطلبة سوريا
        </h1>
        <p className="text-lg text-muted-foreground font-arabic">
          لوحة التحكم الإدارية
        </p>
        <p className="text-sm text-muted-foreground font-caption">
          Syrian Student Union Admin Panel
        </p>
      </div>

      {/* Welcome Message */}
      <div className="mt-6 p-4 bg-muted/50 rounded-lg border border-border" dir="rtl">
        <p className="text-sm text-muted-foreground text-right">
          مرحباً بك في نظام إدارة المحتوى الخاص بالإتحاد العام لطلبة سوريا
        </p>
        <p className="text-xs text-muted-foreground text-right mt-1">
          يرجى تسجيل الدخول للوصول إلى لوحة التحكم
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;